import {Component, Pipe, PipeTransform, Injectable} from '@angular/core';

@Pipe({
    name: 'filterByTitleAndText',
    pure: false
})
@Injectable()
export class FilterByTitleAndTextPipe implements PipeTransform {

    transform(items: any[], filter: string): any {
        if (!items) return [];
        if (!filter) return items;
        filter = filter.toLowerCase();
        return items.filter(item => (item.title.toLowerCase().indexOf(filter) !== -1 || item.text.toLowerCase().indexOf(filter) !== -1));
    }
}
